import { Machine } from '../machine/machine';
import { Status } from '../status/status';
import {Comment} from '../comment/comment';
import {Attachment} from '../attachment/attachment'
import { User } from '../user/user';
import { DispatchOrder } from '../dispatch-order/dispatch-order';

export class Ticketview
{
    id: number; 
    machines: Machine;
title: string;
details: string;
status: Status;
comments: Comment[];
attachment: Attachment[];
user: User;
observer: User;
dateofticket: string;
attachments: Attachment[];
resolution : string ;
errorcode : string;
dateresolved : string;
assigned_to : User; 
dispatchorder: DispatchOrder;
}